import { defineAsyncComponent } from 'vue'

export default {
  enhance: ({ app }) => {    
      app.component("AddScript", defineAsyncComponent(() => import("/home/runner/work/docs/docs/src/.vuepress/components/AddScript.vue")))
  },
}
